import PricingPackages from '../pricing/PricingPackages'

export default function PricingPackagesSection() {
  return (
    <section id="pricing-packages" className="py-16 bg-white dark:bg-gray-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <PricingPackages showHeader={true} />

        {/* Value Proposition */}
        <div className="bg-green-600 text-white rounded-xl p-8 text-center">
          <h3 className="text-2xl font-bold mb-3">💰 Get More Processing Power for Your Money</h3>
          <p className="text-lg mb-6">Buy larger packages and get up to 20% in FREE bonus credits!</p>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: '⚡', title: 'No Expiration', desc: 'Your credits never expire - use them whenever you need' },
              { icon: '🔄', title: 'Auto-Reload Available', desc: 'Set up automatic recharging to never run out' },
              { icon: '🎯', title: 'Pay As You Process', desc: 'Only pay for what you actually use at simple per-credit rates' },
            ].map(item => (
              <div key={item.title} className="bg-white bg-opacity-20 rounded-lg p-4">
                <div className="text-3xl mb-2">{item.icon}</div>
                <div className="font-bold mb-1">{item.title}</div>
                <div className="text-sm opacity-90">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
